import { h } from 'preact';

export default props => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M9.99984 4.16602V15.8327M4.1665 9.99935H15.8332" stroke-width="1.25" stroke-linecap="round" />
	</svg>
);